var _path, _path2, _path3, _path4, _circle, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.346 36.0372C36.346 33.8912 35.2958 31.8792 33.5353 30.6521C31.305 29.0975 28.3022 27.0054 28.3022 27.0054C27.9457 26.7567 27.4731 26.7567 27.1166 27.0054C27.1166 27.0054 24.1138 29.0975 21.8835 30.6521C20.123 31.8792 19.0728 33.8912 19.0728 36.0372V41.6738C19.0728 42.2459 19.5371 42.7102 20.1091 42.7102H35.3096C35.8817 42.7102 36.346 42.2459 36.346 41.6738V36.0372ZM34.2732 36.0372V40.6375H21.1455V36.0372C21.1455 34.5683 21.8641 33.1934 23.0691 32.3532L27.7094 29.1183L32.3497 32.3532C33.5547 33.1934 34.2732 34.5683 34.2732 36.0372Z",
    fill: "#EB731A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.346 19.673V14.0364C36.346 13.4643 35.8817 13 35.3096 13H20.1091C19.5371 13 19.0728 13.4643 19.0728 14.0364V19.673C19.0728 21.819 20.123 23.831 21.8835 25.0581C24.1138 26.6127 27.1166 28.7048 27.1166 28.7048C27.4731 28.9536 27.9457 28.9536 28.3022 28.7048C28.3022 28.7048 31.305 26.6127 33.5353 25.0581C35.2958 23.831 36.346 21.819 36.346 19.673ZM34.2732 19.673C34.2732 21.1419 33.5547 22.5169 32.3497 23.357L27.7094 26.592L23.0691 23.357C21.8641 22.5169 21.1455 21.1419 21.1455 19.673V15.0728H34.2732V19.673Z",
    fill: "#EB731A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0364 15.0728H37.3824C37.9545 15.0728 38.4188 14.6085 38.4188 14.0364C38.4188 13.4643 37.9545 13 37.3824 13H18.0364C17.4643 13 17 13.4643 17 14.0364C17 14.6085 17.4643 15.0728 18.0364 15.0728Z",
    fill: "#EB731A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0364 42.71H37.3824C37.9545 42.71 38.4188 42.2457 38.4188 41.6736C38.4188 41.1015 37.9545 40.6372 37.3824 40.6372H18.0364C17.4643 40.6372 17 41.1015 17 41.6736C17 42.2457 17.4643 42.71 18.0364 42.71Z",
    fill: "#EB731A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2857,
    cy: 28.0001,
    r: 26.2857,
    stroke: "#010101",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5714 28.0001C53.5714 13.4829 41.8029 1.71436 27.2857 1.71436C12.7685 1.71436 1 13.4829 1 28.0001C1 33.8501 2.91103 39.2537 6.14286 43.6208",
    stroke: "#010101",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26.8576L53.5714 30.2861L50.1429 26.8576",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.f588647b30eee7b2c631671c93fd6e58.svg";
export { ForwardRef as ReactComponent };